import styled from 'styled-components'
import { Col } from '../Grid'

export default styled(Col)`
  
`
